// import Bugsnag from '@bugsnag/js';
import $services from '@/config/container';
import Service from '@/config/service-identifiers';
import Vue from "vue";
import { AccessTokenKey, AUTH_STATE_COOKIE } from '@/store/auth/auth.store.constants';
import { getLoggedUser } from '@/services/backend/myself/myselfService'

export default {

  state: {
    user: {},
    roles: [],
    member: {},
    // null = not yet checked, 'invited' = pending invitation (status 7), 'not-invited' = anything else (cached for the session)
    labIdeasInvitationStatus: null,
  },
  getters: {
    loggedUser: ({ user }) => user,
    loggedMember: ({ member }) => member,
    loggedMemberRoles: ({ roles }) => roles,
    isInvitedToLabDeIdeas: ({ labIdeasInvitationStatus }) => labIdeasInvitationStatus === 'invited',
    labIdeasInvitationChecked: ({ labIdeasInvitationStatus }) => labIdeasInvitationStatus !== null,
  },
  mutations: {
    setLoggedUser(state, { user, member, roles }) {
      state.user = user ? user : {};
      state.member = member ? member : {};
      state.roles = roles ? roles : [];
    },
    updateUser(state, partialUser) {
      state.user = {
        ...state.user,
        ...partialUser,
      };
    },
    setLabIdeasInvitationStatus(state, status) {
      state.labIdeasInvitationStatus = status;
    },
    logout(state) {
      state.user = {};
      state.member = {};
      state.labIdeasInvitationStatus = null;
    },
  },
  actions: {
    /**
     * Fetch the logged user information
     */
    async fetchLoggedUser2({ commit }, params) {
      // console.log('fetchLoggedUser2 params: ', params)
      
      // Normalize communitySlug if it's an object
      if (params && params.communitySlug) {
        if (typeof params.communitySlug === 'object' && params.communitySlug !== null) {
          console.log('Normalizing communitySlug object in fetchLoggedUser2:', params.communitySlug);
          params.communitySlug = params.communitySlug.slug || params.communitySlug.id || '';
          console.log('Normalized to:', params.communitySlug);
        }
        
        // Check for invalid slugs
        if (!params.communitySlug || params.communitySlug === 'error' || params.communitySlug === 'undefined') {
          console.log('Invalid communitySlug detected in fetchLoggedUser2:', params.communitySlug);
          params.communitySlug = null;
        }
      }
      
      try {
        const { data } = await getLoggedUser(params)
        // console.log('getLoggedUser (response.data): ', data)
        commit('setLoggedUser', data);
        // return response.data.user;
      } catch (error) {
        // If user does not have authorization to enter, delete cookies go to login
        // console.log('failed getting user, redirecting to login...');

        // Remove cookies
        Vue.$cookies.remove('lastUrl');
        Vue.$cookies.remove('registeredTo');
        Vue.$cookies.remove(AccessTokenKey);
        Vue.$cookies.remove(AUTH_STATE_COOKIE);

        // Redirect
        let route = '/';
        if(process.env.VUE_APP_CUSTOMER === 'nexos') {
          // console.log('isNexos');
          route = process.env.VUE_APP_URL + '/' + process.env.VUE_APP_MAIN_SPACE_SLUG + '/auth/login';
          // console.log('userData.js - Redirecting to Nexos Login:', route);
          window.location.href = route;
        } else {
          // console.log('is NOT Nexos');
        }
        // console.log('route', route);
        // this.$router.push(route);
        
        if (error.response?.status === 401) {
          return 401;
        }
        return error.response;
      }
    },
    async fetchLoggedUser({ commit, getters, dispatch }) {
      // console.log('fetchLoggedUser')
      let communitySlug = window.location.pathname.split('/')[1];
      
      // Better handle different types of communitySlug
      if (typeof communitySlug === 'object' && communitySlug !== null) {
        console.log('Normalizing communitySlug object in fetchLoggedUser:', communitySlug);
        communitySlug = communitySlug.slug || null;
      }
      
      // Handle invalid values
      if (!communitySlug || communitySlug === 'error' || communitySlug === 'undefined'){
        console.log('Invalid communitySlug detected in fetchLoggedUser:', communitySlug);
        communitySlug = null;
      }
      
      try {
        const response = await $services[Service.BackendClient].get(
          '/myself', 
          communitySlug && communitySlug != 'my' ? { params: { communitySlug } } : ''
        );
        // console.log('getLoggedUser (responseOLD): ', response)
        commit('setLoggedUser', response.data);
        return response.data.user;
      } catch (error) {
        // If user does not have authorization to enter, delete cookies go to login
        if (error.response.status === 401) {
          return 401;
        }
        // if (Bugsnag.notify?.error) {
        //   Bugsnag.notify.error({
        //     title: 'Error',
        //     message: error.response.data.message,
        //   });
        // }

        return null;
      }
    },

    async updateUserLocale({ commit, getters }, { languageCode }) {
      await $services[Service.BackendClient].put('users', {
        userKey: getters.loggedUser.key,
        languageCode,
      });
      commit('updateUser', { languageCode });
    },
    async updateMemberLanguage({ rootGetters }, { languageCode }) {
      await $services[Service.BackendClient].post('memberLanguage', {
        communityKey: rootGetters.currentCollective.key,
        memberKey: rootGetters.loggedMember.key,
        languageCode,
      });
    },
    /**
     * Check whether the logged user has a pending invitation to the
     * `lab-de-ideas` space. The result is cached in `state.labIdeasInvitationStatus`
     * for the whole session so we don't hammer the backend on every navigation.
     */
    async checkLabDeIdeasInvitation({ state, commit }) {
      if (state.labIdeasInvitationStatus !== null) return;
      try {
        const { data } = await $services[Service.BackendClient].get('/communities', {
          params: {
            page: 1,
            orderByDate: 1,
            checkStatus: true,
            communitySlug: 'lab-de-ideas',
          },
        });
        const status = Number(data?.data?.[0]?.status);
        commit('setLabIdeasInvitationStatus', status === 7 ? 'invited' : 'not-invited');
      } catch (error) {
        // Leave the status as null so a future navigation can retry.
        // We deliberately swallow the error to avoid noisy UX on transient failures.
      }
    },
  },
};
